<template>
    <div class="check-table" ref="checkTable">
        <div class="table-top">
            <span class="table-top_btn" @click="addTarget">添加指标</span>
            <span v-loading="loadingXls" class="table-top_btn" @click="exportTarget">导出数据</span>
            <span v-loading="loadingSave" class="table-top_btn" @click="saveTemplate">保存模板</span>
        </div>
        <el-table
            v-if="tableHeight != 0"
            ref="multipleTable"
            :data="templateInfo.indicators"
            :header-cell-style="{ background: '#f2f2f2', color: '#222' }"
            :height="tableHeight"
            border
            class="el-table"
            style="width: 100%;"
            @selection-change="handleSelectionChange"
            >
            <el-table-column
                type="selection"
                width="40">
            </el-table-column>
            <el-table-column
                align="center"
                prop="targetNameCh"
                width="230"
                label="指标名称"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                align="center"
                prop="source"
                width="70"
                label="来源"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                align="center"
                width="70"
                prop="frequence"
                label="频率"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                align="center"
                width="70"
                prop="unit"
                label="单位"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                align="center"
                prop="startDate"
                label="开始时间"
                width="100"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <span>{{ setTime(scope.row.startDate) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                prop="endDate"
                label="结束时间"
                width="100"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <span>{{ setTime(scope.row.endDate) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                prop="describes"
                label="描述"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column label="操作" align="center" width="80" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button
                        style="color: #D3131A;"
                        size="mini"
                        type="text"
                        icon="el-icon-delete"
                        @click="SET_DEL_INFO(scope.row)"
                    >删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { parseTime, formatDate } from "@/utils/ruoyi"
import { mapGetters, mapMutations, mapActions } from "vuex"
import { exportXls } from "@/api/dataCenter"
import { streamFile } from "@/utils/load"
export default {
    props: {
        tableHeight: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loading: false,
            loadingSave: false,
            loadingXls: false
        }
    },
    computed: {
        ...mapGetters(["templateInfo", "isAdd", ""]),
        // 设置时间
        setTime() {
            return function (time) {
                return parseTime(formatDate(time), '{y}-{m}-{d}')
            }
        }
    },
    watch: {
        'templateInfo.indicators': function () {
            this.setAll()
        },
    },
    mounted() {
        this.setAll()
    },
    methods: {
        ...mapMutations([
            "SET_IS_ADD", 
            "SET_TEMPLATE_INDICATORS", 
            "SET_TEMPLATE_INFO", 
            "SET_DEL_INFO",
            "SET_TABLE_DATA"
        ]),
        ...mapActions(["AddTemplate"]),
        // 全选
        setAll() {
            this.$nextTick(() => {
                this.templateInfo.indicators.forEach((item) => {
                    this.$refs.multipleTable.toggleRowSelection(item, true);
                })
            })
        },
        // 添加指标
        addTarget() {
            const { id, indicators } = this.templateInfo
            if (id) {
                this.SET_IS_ADD(true)
                this.SET_TEMPLATE_INDICATORS(indicators)
            } else {
                this.SET_IS_ADD(false)
                this.SET_TEMPLATE_INFO()
            }
            this.$emit("changeLeft", 0)
        },
        // 导出指标 
        exportTarget() {
            const indicators = this.templateInfo.indicators
            this.loadingXls = true
            let ids = []
            if (indicators && indicators.length > 0) {
                indicators.forEach(item => {
                    ids.push(item.datasourceId)
                })
            }
            exportXls({datasourceIds: ids.join(",")}).then(res => {
                this.loadingXls = false
                streamFile(res)
            }).catch(() => {
                this.loadingXls = false
            })
        },
        // 保存模板
        saveTemplate()  {
            // 获取所选的id
            this.loadingSave = true
            const  { id, indicators } = this.templateInfo
            let targetIds = []
            if (indicators.length > 0) {
                indicators.forEach(item => {
                    targetIds.push(item.id)
                })
            }
            const form = {
                id: id,
                targetIds: targetIds.join(",")
            }
            this.AddTemplate(form).then(res => {
                this.loadingSave = false
            }).catch(() =>{
                this.loadingSave = false
            })
        },
        // 选择指标
        handleSelectionChange(val) {
            this.SET_TABLE_DATA(val)
        }
    }
};
</script>

<style lang="less">
@import '../common.less';
</style>